(() => {
  if (window.ProductThreeColumnPinnedInitialized) return;
  window.ProductThreeColumnPinnedInitialized = true;

  class ProductThreeColumnPinned {
    constructor(sectionRoot) {
      this.sectionRoot = sectionRoot;
      this.rafId = null;
      this.resizeObserver = null;
      this.boundRequestUpdate = this.requestUpdate.bind(this);
      this.boundUpdate = this.update.bind(this);
      this.isBound = false;
    }

    getElements() {
      const productRoot = this.sectionRoot.querySelector('.product--info-layout-three-column');
      if (!productRoot) return null;

      const mediaWrapper = productRoot.querySelector('.product__media-wrapper');
      const leftWrapper = productRoot.querySelector('.product__info-wrapper--left');
      const rightWrapper = productRoot.querySelector('.product__info-wrapper--right');
      const leftContent = leftWrapper ? leftWrapper.querySelector('.product__column-sticky') : null;
      const rightContent = rightWrapper ? rightWrapper.querySelector('.product__column-sticky') : null;

      return {
        productRoot,
        mediaWrapper,
        leftWrapper,
        rightWrapper,
        leftContent,
        rightContent,
      };
    }

    getHeaderOffset() {
      const rootStyles = getComputedStyle(document.documentElement);
      const headerBottomDesktop = parseFloat(rootStyles.getPropertyValue('--header-bottom-position-desktop')) || 0;
      const headerBottom = parseFloat(rootStyles.getPropertyValue('--header-bottom-position')) || 0;

      return Math.max(headerBottomDesktop, headerBottom, 0) + 75;
    }

    getPinnedTop(contentHeight) {
      const headerOffset = this.getHeaderOffset();
      const availableHeight = Math.max(window.innerHeight - headerOffset, 0);

      return headerOffset + Math.max((availableHeight - contentHeight) / 2, 0);
    }

    setStickyOffset(productRoot) {
      if (!productRoot) return;

      productRoot.style.setProperty('--product-three-column-sticky-top', `${Math.round(this.getHeaderOffset())}px`);
    }

    setColumnStickyState(productRoot, content) {
      if (!productRoot || !content) return;

      const contentHeight = content.scrollHeight || content.offsetHeight;
      content.style.top = `${Math.round(this.getPinnedTop(contentHeight))}px`;
    }

    resetColumn(wrapper, content) {
      if (wrapper) {
        wrapper.style.removeProperty('min-height');
      }

      if (!content) return;

      content.style.position = '';
      content.style.top = '';
      content.style.bottom = '';
      content.style.left = '';
      content.style.right = '';
      content.style.width = '';
      content.style.transform = '';
      content.style.willChange = '';
      content.style.zIndex = '';
    }

    setPinned(wrapper, content, translateY) {
      content.style.position = 'absolute';
      content.style.top = `${translateY}px`;
      content.style.bottom = '';
      content.style.left = '0';
      content.style.right = '0';
      content.style.width = '100%';
      content.style.transform = 'none';
      content.style.willChange = '';
      content.style.zIndex = '2';
    }

    updateColumn(wrapper, content) {
      if (!wrapper || !content) return;

      const wrapperRect = wrapper.getBoundingClientRect();
      const wrapperTop = window.scrollY + wrapperRect.top;
      const wrapperHeight = wrapper.offsetHeight;
      const contentHeight = content.offsetHeight;
      const pinnedTop = this.getPinnedTop(contentHeight);
      const maxTranslate = Math.max(wrapperHeight - contentHeight, 0);
      const translateY = Math.round(Math.min(Math.max(window.scrollY + pinnedTop - wrapperTop, 0), maxTranslate));

      this.setPinned(wrapper, content, translateY);
    }

    update() {
      this.rafId = null;

      const elements = this.getElements();
      if (!elements) return;

      const { productRoot, leftWrapper, rightWrapper, leftContent, rightContent } = elements;
      const gridIsActive = getComputedStyle(productRoot).display === 'grid';
      const desktopThreeColumnActive = window.matchMedia('(min-width: 1200px)').matches;

      if (!desktopThreeColumnActive || !gridIsActive) {
        productRoot.style.removeProperty('--product-three-column-sticky-top');
        this.resetColumn(leftWrapper, leftContent);
        this.resetColumn(rightWrapper, rightContent);
        return;
      }

      this.setStickyOffset(productRoot);
      this.resetColumn(leftWrapper, leftContent);
      this.resetColumn(rightWrapper, rightContent);
      this.setColumnStickyState(productRoot, leftContent);
      this.setColumnStickyState(productRoot, rightContent);
    }

    requestUpdate() {
      if (this.rafId) return;
      this.rafId = requestAnimationFrame(this.boundUpdate);
    }

    bind() {
      if (this.isBound) return;
      this.isBound = true;

      this.requestUpdate();
      window.addEventListener('load', this.boundRequestUpdate);
      window.addEventListener('resize', this.boundRequestUpdate);

      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(this.boundRequestUpdate);
        const elements = this.getElements();

        if (elements) {
          [
            elements.mediaWrapper,
            elements.leftWrapper,
            elements.rightWrapper,
            elements.leftContent,
            elements.rightContent,
          ].forEach((element) => {
            if (element) this.resizeObserver.observe(element);
          });
        }
      }
    }
  }

  const controllers = new Map();

  function initSection(sectionRoot) {
    if (!sectionRoot) return;

    if (controllers.has(sectionRoot)) {
      controllers.get(sectionRoot).requestUpdate();
      return;
    }

    const controller = new ProductThreeColumnPinned(sectionRoot);
    controller.bind();
    controllers.set(sectionRoot, controller);
  }

  function initAllSections() {
    document.querySelectorAll('[id^="MainProduct-"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections, { once: true });
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;

    initSection(document.getElementById(`MainProduct-${sectionId}`));
  });
})();
